import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['hiddenItem', 'toggleButton', 'toggleText', 'toggleIcon'];

  connect() {
    this.isExpanded = false;
    this.showAllText = this.toggleTextTarget.textContent;
    this.showLessText =
      this.element.getAttribute('data-show-less-text') || 'Weniger anzeigen';

    // Initially hide all hidden items
    this.hiddenItemTargets.forEach(item => {
      item.style.display = 'none';
    });

    this.updateToggleButton();
  }

  toggle() {
    this.isExpanded = !this.isExpanded;

    this.hiddenItemTargets.forEach(item => {
      if (this.isExpanded) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    });

    this.updateToggleButton();
  }

  updateToggleButton() {
    if (this.isExpanded) {
      this.toggleTextTarget.textContent = this.showLessText;
      this.toggleIconTarget.classList.add('icon--rotate-180');
    } else {
      this.toggleTextTarget.textContent = this.showAllText;
      this.toggleIconTarget.classList.remove('icon--rotate-180');
    }
  }
}
